import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'xea-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IconButtonComponent implements OnInit {
  @Input() public icon: string;
  @Input() public label: string;
  @Input() public e2eAttr: string;
  @Input() public withPadding: boolean = true;

  @Output() public click: EventEmitter<void> = new EventEmitter();

  public constructor() {}

  public ngOnInit() {}

  public onClick(): void {
    this.click.emit();
  }
}
